// @flow
import React, { type Node, useMemo } from 'react';
import path from 'ramda/es/path';

import * as orgsTypes from 'app/common/constants/schools/types';
import SimpleDate from 'app/dataProviders/SimpleDate';

import CardContent from './CardContent';


type Props = {
  date: string,
  students: {
    keys: Array<number>,
    data: Object,
  },
  isCurrentUserStudent: boolean,
}

const CardsContent = ({ date, students, isCurrentUserStudent }: Props): Node => {
  const { keys, data } = students;

  const currentDate = useMemo(() => new SimpleDate(date, 'YYYY-MM-DD'), [date]);

  return keys.map((id) => {
    const orgType = path([id, 'orgType'], data);
    const klassId = path([id, 'klassId'], data);
    const enablePassages = (orgType === orgsTypes.SCHOOL || orgType === orgsTypes.PRESCHOOL
      ? !isCurrentUserStudent // ученикам в школах и дет. садах не показываем
      : true
    );

    return (
      <CardContent
        key={id}
        klassId={klassId ? String(klassId) : null}
        studentId={String(id)}
        date={currentDate}
        enablePassages={enablePassages}
      />
    );
  });
};

export default CardsContent;
